export default __webpack_public_path__ + "static/cameron_b-24e248566595797900b2a7e5f5e23c90.png";